export const validate = function(fields) {
   let errors = {};
   for (let field of fields.target) {
      if(field.type == 'submit') break;

      var fieldValue = field.value;
      var name       = field.getAttribute("data-name");
      var fieldName  = field.getAttribute("name");
      var minLength  = field.getAttribute("minlength");
      var maxLength  = field.getAttribute("maxLength");
      var required   = field.getAttribute("required");
      var validate   = field.getAttribute("validate");

      if (minLength && fieldValue.length < minLength) {
         errors[fieldName] = `O campo ${name} exige um mínimo de ${minLength} caracteres.`
      }

      if (required && !fieldValue.length) {
         errors[fieldName] = `O campo ${name} é obrigatório.`
      }

      if (maxLength) {
         if (fieldValue.length > maxLength)
         errors[fieldName] = `O campo ${name} exige um máximo de ${maxLength} caracteres.`
      }

      if (validate) {
         switch (validate) {
            case 'email':
               if (!validEmail(fieldValue)) {
                  errors[fieldName] = `Digite um email válido.`
               }
            break;
            case 'new-pass':
                if (!validPassword(fieldValue)) {
                  errors[fieldName] = 'A senha deve conter letras, números e, no minimo, 8 caracteres.'
                }
            break;
            case 'login':
                if (!validLogin(fieldValue)) {
                  errors[fieldName] = 'O login pode conter apenas caracteres do alfabeto, sem acento ou cedilha.'
                }
            break;

            default:

         }
      }
   }
   return errors;
}

function validEmail(email) {
  if (email != "") {
   var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
   return re.test(email);
 }
 return true;
}

function validPassword(pass) {
  if (pass != "") {
      var re = /^((?=.*[A-Za-z])(?=.*\d)[A-Za-z\d])|((?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]){8,}$/;
      return re.test(pass);
 }
 return true;
}

function validLogin(login) {
  if (login != "") {
      var re = /^(?=.*[a-z])|(?=.*[A-Z]){6,}$/;
      return re.test(login);
 }
 return true;
}

export const getBaseUrl = function() {
   return  process.env.NODE_ENV === 'production' ? '' : ''
}



// WEBPACK FOOTER //
// ./src/js/utils/index.js